import React, { useState, useEffect } from "react";
import Editor from "@monaco-editor/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHtml5, faCss3Alt, faJsSquare } from '@fortawesome/free-brands-svg-icons';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

const App = () => {
  const [darkMode, setDarkMode] = useState(true);
  const [htmlCode, setHtmlCode] = useState("<h1>Hello World</h1>");
  const [cssCode, setCssCode] = useState("h1 { \ncolor: blue;\n}");
  const [jsCode, setJsCode] = useState("console.log('Hello World');");
  const [srcDoc, setSrcDoc] = useState('');

  const runCode = () => {
    const result = `
      <html>
        <head>
          <style>${cssCode}</style>
        </head>
        <body>
          ${htmlCode}
          <script>${jsCode}</script>
        </body>
      </html>
    `;
    setSrcDoc(result);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      runCode();
    }, 250);
    return () => clearTimeout(timeout);
  }, [htmlCode, cssCode, jsCode]);

  return (
    <div className={`${darkMode ? "bg-gray-900 text-white" : "bg-white text-black"} h-screen`}>
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b border-gray-700">
        <h1 className="text-lg font-bold">Live Code Editor</h1>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="flex items-center px-4 py-2 rounded bg-blue-500 text-white hover:bg-blue-600"
        >
          <FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="mr-2" />
        </button>
      </div>

      {/* Editors and Run Code Button */}
      <div className="flex h-[70%]">
        {/* Code Editors */}
        <div className="flex flex-col w-1/3 p-2">
          <div className="flex items-center justify-center mb-2">
            <FontAwesomeIcon icon={faHtml5} size="2x" className="text text-red-400"/>
          </div>
          <Editor
            height="100%"
            defaultLanguage="html"
            theme={darkMode ? "vs-dark" : "vs-light"}
            value={htmlCode}
            onChange={(newValue) => setHtmlCode(newValue)}
          />
        </div>

        <div className="flex flex-col w-1/3 p-2">
          <div className="flex items-center justify-center mb-2">
            <FontAwesomeIcon icon={faCss3Alt} size="2x" className="text text-blue-500"/>
          </div>
          <Editor
            height="100%"
            defaultLanguage="css"
            theme={darkMode ? "vs-dark" : "vs-light"}
            value={cssCode}
            onChange={(newValue) => setCssCode(newValue)}
          />
        </div>

        <div className="flex flex-col w-1/3 p-2">
          <div className="flex items-center justify-center mb-2">
            <FontAwesomeIcon icon={faJsSquare} size="2x" className="text text-yellow-300"/>
          </div>
          <Editor
            height="100%"
            defaultLanguage="javascript"
            theme={darkMode ? "vs-dark" : "vs-light"}
            value={jsCode}
            onChange={(newValue) => setJsCode(newValue)}
          />
        </div>
      </div>

      {/* Run Code Button */}
      <div className="flex justify-center p-4">
        <button
          onClick={runCode}
          className="px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600"
        >
          Run Code
        </button>
      </div>

      {/* Result Frame */}
      <iframe
        srcDoc={srcDoc}
        title="Result"
        sandbox="allow-scripts"
        style={{ backgroundColor: 'white' }} // Ensures the iframe background is white
        className="w-full h-[30%] border border-gray-700"
      />
    </div>
  );
};

export default App;